import { State } from '../StateTypes';

/**
 * Select vpc
 *
 * @param vpc
 */
export const selectVpcSlice = ({ vpc }: State) => vpc;

/**
 * Select vpc save state
 * @param state
 */
export const selectSaveVpcState = (state: State) =>
  selectVpcSlice(state).save.state;

/**
 * Select saved vpc code
 * @param state
 */
export const selectSavedVpcCode = (state: State) =>
  selectVpcSlice(state).save?.code;

/**
 * Select last saved vpc config
 * @param state
 */
export const selectDirtyConfigurationState = (state: State) =>
  selectVpcSlice(state).save.dirtyConfiguration;

/**
 * Select save VPC progress status
 * @param state
 */
export const selectSaveVpcProgressStatus = (state: State) =>
  selectVpcSlice(state).save.progressStatus;
